import { AutoComplete, FormLabel } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Spacer, StyledInput } from "../StyledComponents";
import { getOptionLabel } from "../helper";
import TimeSection from "../../time-section/TimeSection";
import { LabelledValue } from "@kaltura/mediaspace-shared-types";
import { SyntheticEvent } from "react";
import { EmbedSettingsAvailableFeatures } from "../embed-helpers/EmbedHelperV7";

const staticClassBase = "kms-ds-share-modal-embed-form";

interface EmbedFormProps {
    enabledFeatures: EmbedSettingsAvailableFeatures;
    embedCode: string;
    selectedPlayer: LabelledValue;
    playersOptions: LabelledValue[];
    handlePlayerSelect: (selectedPlayer: LabelledValue) => void;
    embedSizesOptions: LabelledValue[];
    selectedEmbedSize: LabelledValue;
    handleEmbedSizeSelect: (selectedEmbedSize: LabelledValue) => void;
    onTimeUpdate: (startTime: number) => void;
    embedMethod: "embed" | "oembed";
}

const EmbedForm = (props: EmbedFormProps) => {
    const {
        enabledFeatures,
        embedCode,
        selectedPlayer,
        playersOptions,
        handlePlayerSelect,
        embedSizesOptions,
        selectedEmbedSize,
        handleEmbedSizeSelect,
        onTimeUpdate,
        embedMethod,
    } = props;

    const onPlayerSelect = (event: SyntheticEvent<Element, Event>, selectedPlayer: LabelledValue) =>
        handlePlayerSelect(selectedPlayer);
    const onEmbedSizeSelect = (event: SyntheticEvent<Element, Event>, selectedEmbedSize: LabelledValue) =>
        handleEmbedSizeSelect(selectedEmbedSize);

    return (
        <>
            {enabledFeatures.embedCodeText && (
                <>
                    <FormLabel label={translate("Embed code")} controlID={`${staticClassBase}-input-embed-code`} />
                    <StyledInput
                        id={`${staticClassBase}-input-embed-code`}
                        multiline={true}
                        fullWidth={true}
                        rows={4}
                        value={embedCode}
                        readOnly={true}
                    />
                    <Spacer />
                </>
            )}

            <FormLabel label={translate("Choose player")} controlID={`${staticClassBase}-form-select-player`} />
            <AutoComplete
                id={`${staticClassBase}-form-select-player`}
                value={selectedPlayer}
                options={playersOptions}
                getOptionLabel={getOptionLabel}
                onChange={onPlayerSelect}
                multiple={false}
                fullWidth={true}
            />

            {enabledFeatures.embedSizes && (
                <>
                    <Spacer />
                    <FormLabel
                        label={translate("Max embed size")}
                        controlID={`${staticClassBase}-form-select-embed-sizes`}
                    />
                    <AutoComplete
                        id={`${staticClassBase}-form-select-embed-sizes`}
                        value={selectedEmbedSize}
                        options={embedSizesOptions}
                        getOptionLabel={getOptionLabel}
                        onChange={onEmbedSizeSelect}
                        multiple={false}
                        fullWidth={true}
                    />
                </>
            )}

            {enabledFeatures.timeSelect && (
                <>
                    <Spacer />
                    <TimeSection onTimeUpdate={onTimeUpdate} embedMethod={embedMethod} />
                </>
            )}
        </>
    );
};

export default EmbedForm;
